import React, { useEffect, useState } from 'react';
import './RifasMain.css'
import { Link as Anchor } from "react-router-dom";
import baseURL from '../../url';
import useApiWithLoader from '../../../hooks/useApiWithLoader';
export default function RifasMain() {
    const [rifas, setRifas] = useState([]);
    const { apiCall } = useApiWithLoader();

    useEffect(() => {
        cargarRifas();
    }, []);

    const cargarRifas = () => {
        apiCall(async () => {
            const response = await fetch(`${baseURL}/rifaGet.php`, {
                method: 'GET',
            });
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const data = await response.json();
            if (data && Array.isArray(data.rifas)) {
                setRifas(data.rifas.reverse().slice(0, 5));
            } else {
                setRifas([]);
            }
        }).catch(error => {
            console.error('Error loading rifas:', error);
            setRifas([]);
        });
    };

    return (

        <div className='table-containerUsuarios'>
            <div className='deFlexMore'>
                <h3>Ultimos {Array.isArray(rifas) ? rifas.length : 0} registros</h3>
                <Anchor to={`/dashboard/rifas`} className='logo'>
                    Ver más
                </Anchor>
            </div>

            <table className='table'>
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>Nombre</th>
                        <th>Estado</th>
                        <th>Finalizacion</th>
                        <th>Creacion</th>

                    </tr>
                </thead>
                <tbody>
                    {Array.isArray(rifas) && rifas.length > 0 ? rifas.map(item => (
                        <tr key={item.idRifa}>
                            <td>{item.idRifa}</td>
                            <td>{item.nombre}</td>
                            <td style={{
                                color: item?.estado === 'disponible' ? '#008000' : item?.estado === 'finalizada' ? '#FF0000' : '#000000',
                            }}>
                                {`${item?.estado}`}
                            </td>
                            <td>{item.finalizacion}</td>
                            <td>{item.createdAt}</td>
                        </tr>
                    )) : (
                        <tr>
                            <td colSpan="5" style={{ textAlign: 'center', padding: '20px' }}>
                                No hay rifas disponibles
                            </td>
                        </tr>
                    )}
                </tbody>

            </table>
        </div>

    );
};
